module.exports = __webpack_public_path__ + "static/media/logoblanco-canimolt_footer.35fb5560.png";